import React from 'react'
import _ from 'lodash'

import {MessageService} from 'api/message'

import {Button, Dropdown, Icon, Input, InputNumber, Menu, Modal} from 'antd'
import {Row, Col} from 'react-flexbox-grid'

import {TriStateTag} from 'ui'

const flatpack = (obj, acc, p) => {
   let path = p || []

   return _.reduce(
      obj,
      (newacc, v, k) => {
         let arrk = path.concat(k)

         if (_.isPlainObject(v)) {
            return flatpack(v, newacc, arrk)
         } else {
            newacc[arrk.join('.')] = v
         }

         return newacc
      },
      undefined === acc ? {} : acc
   )
}

const ActivityItem = ({key, datetime, ...rest}) => {
   let proto = rest['proto/tm'],
      type = proto.type + '/' + (proto.detail || proto.command)

   switch (type) {
      case 'event/config':
         return (
            <tr key={key}>
               <td>{datetime}</td>
               <td>{type}</td>
               <td>{proto.packet_number}</td>
               <td>Version {proto.config.device.fw_revision} ({proto.config.device.part})</td>
            </tr>
         )
      case 'event/ack':
      case 'event/nak':
         return (
            <tr key={key}>
               <td>{datetime}</td>
               <td>{type}</td>
               <td>{proto.packet_number}</td>
               <td>
                  Command Number: {proto.cmd_number}
                  {proto.reason ? <span>, NAK Reason: {proto.reason}</span> : null}
               </td>
            </tr>
         )
      case 'command/set_config':
         return (
            <tr key={key}>
               <td>{datetime}</td>
               <td>{type}</td>
               <td>{proto.packet_number}</td>
               <td>
                  {' '}
                  Fields:
                  {' '}
                  {_.map(flatpack(proto.config), (v, k) => (
                     <span className="field"><em>{k} := {v},</em></span>
                  ))}
               </td>
            </tr>
         )

      case 'event/reset':
         return (
            <tr key={key}>
               <td>{datetime}</td>
               <td>{type}</td>
               <td>{proto.packet_number}</td>
               <td>Trigger: <b>{proto.trigger}</b></td>
            </tr>
         )

      default:
         return (
            <tr key={key}>
               <td>{datetime}</td>
               <td>{type}</td>
               <td>{proto.packet_number ? proto.packet_number : proto.cmd_number}</td>
            </tr>
         )
   }
}

ActivityItem.propTypes = {
   key:      React.PropTypes.string.isRequired,
   datetime: React.PropTypes.string.isRequired
}

const CmdNumField = ({onChange}) => (
   <InputNumber
      min={0}
      max={255}
      placeholder="Command Number"
      label="Command Number"
      onChange={val => onChange('cmd_number', val)}
   />
)

CmdNumField.propTypes = {
   onChange: React.PropTypes.func.isRequired
}

const GPIOStateField = ({onChange, ...props}) => {
   const myChange = (field, value) => {
      const pin = field.split('.')[1]

      onChange(field, state => {
         let gpios = (state.gpio = _.get(state, 'gpio', {}))

         if (null === value) {
            delete gpios[pin]
         } else {
            gpios[pin] = value
         }

         return _.set(state, 'gpio', gpios)
      })
   }

   return (
      <span>
         <TriStateTag {...props} onChange={myChange} field="gpio.0">
            GPIO 0
         </TriStateTag>
         <TriStateTag {...props} onChange={myChange} field="gpio.1">
            GPIO 1
         </TriStateTag>
         <TriStateTag {...props} onChange={myChange} field="gpio.2">
            GPIO 2
         </TriStateTag>
         <TriStateTag {...props} onChange={myChange} field="gpio.3">
            GPIO 3
         </TriStateTag>
         <TriStateTag {...props} onChange={myChange} field="gpio.4">
            GPIO 4
         </TriStateTag>
         <TriStateTag {...props} onChange={myChange} field="gpio.5">
            GPIO 5
         </TriStateTag>
         <TriStateTag {...props} onChange={myChange} field="gpio.6">
            GPIO 6
         </TriStateTag>
         <TriStateTag {...props} onChange={myChange} field="gpio.7">
            GPIO 7
         </TriStateTag>

      </span>
   )
}

GPIOStateField.propTypes = {
   onChange: React.PropTypes.func.isRequired
}

const PwmOutputField = ({onChange}) => (
   <InputNumber min={0} max={100} placeholder="PWM" onChange={val => onChange('pwm', val)} />
)

PwmOutputField.propTypes = {
   onChange: React.PropTypes.func.isRequired
}

const ConfigField = _props => <span>How can she config?</span>
const SerialOutputField = ({onChange}) => (
   <Input placeholder="Serial Data" onChange={ev => onChange('data', ev.target.value)} />
)

SerialOutputField.propTypes = {
   onChange: React.PropTypes.string.isRequired
}

const CommandInput = ({command, onChange}) => (
   <Row>
      {_.map(command.fields, (Component, idx) => (
         <Col key={idx}><Component onChange={onChange} /></Col>
      ))}
   </Row>
)

CommandInput.propTypes = {
   command:  React.PropTypes.object.isRequired,
   onChange: React.PropTypes.func
}

const commands = {
   'command/set_output': {
      label:      'Set Outputs',
      conditions: [],
      fields:     [CmdNumField, GPIOStateField]
   },
   'command/set_pwm':        {label: 'Set PWM', conditions: [], fields: [CmdNumField, PwmOutputField]},
   //  'command/set_config': {
   //     label:      'Set Configuration',
   //     conditions: [],
   //     fields:     [CmdNumField, ConfigField]
   //  },
   'command/init_gw_config': {
      label:      'Set Gateway in Config Mode',
      conditions: [],
      fields:     [CmdNumField]
   },
   'command/serial': {
      label:      'Send Serial Data',
      conditions: [],
      fields:     [CmdNumField, SerialOutputField]
   },
   'command/get_nid':        {label: 'Get NID', conditions: [], fields: [CmdNumField]},
   'command/get_status':     {label: 'Get Status', conditions: [], fields: [CmdNumField]},
   'command/get_did_status': {label: 'Get DID Status', conditions: [], fields: [CmdNumField]},
   'command/get_config':     {
      label:      'Get Configuration Memory',
      conditions: [],
      fields:     [CmdNumField]
   },
   'command/get_calibration': {
      label:      'Get Calibration Memory',
      conditions: [],
      fields:     [CmdNumField]
   },
   'command/force_reset': {label: 'Force Router Reset', conditions: [], fields: [CmdNumField]},
   'command/get_path':    {label: 'Get Packet Path', conditions: [], fields: [CmdNumField]}
}

export class Activity extends React.Component {
   constructor(p) {
      super(p)

      this.state = {command: {}, publishing: false}

      this.updateCmd = this.updateCmd.bind(this)
      this.onSend = this.onSend.bind(this)
      this.onError = this.onError.bind(this)
   }

   static get propTypes() {
      return {
         messages: React.PropTypes.array,
         location: React.PropTypes.object,
         router:   React.PropTypes.object,
         device:   React.PropTypes.object.isRequired
      }
   }

   updateCmd(path, value) {
      if (_.isFunction(value)) {
         this.setState(state => _.set(state, 'command', value(state.command)))
      } else if (null === value) {
         this.setState(state => _.omit(state, 'command.' + path))
      } else {
         this.setState(state => _.set(state, 'command.' + path, value))
      }
   }

   onSend(ev) {
      ev.preventDefault()

      let {location} = this.props,
         proto = _.assign(
            {cmd_number: Math.floor(Math.random() * 1000 % 128)},
            this.state.command,
            {
               type:    'command',
               command: _.get(location, 'query.command', '/').split('/')[1]
            }
         )

      let {key, network} = this.props.device,
         command = {
            'proto/tm': proto
         }

      MessageService.write(network, key, command, false)
         .then(r => {
            if (_.isError(r)) {
               this.setState({publishing: false}, () => this.onError(r))
            } else {
               this.setState({publishing: false, command: {}})
            }
         })
         .catch(error => {
            this.setState({publishing: false}, () => this.onError(error))
         })

      this.setState({publishing: true})
   }

   onError(error) {
      let msg

      if (error.data) {
         msg = error.data.error || error.data.message || error.toString()
      } else if (_.isError(error)) {
         msg = error.toString()
      }

      Modal.error({
         title:   'Failed to publish message',
         content: msg
      })
   }

   render() {
      let {messages, location, router} = this.props

      const CmdMenu = (
         <Menu>
            {_.map(commands, ({label}, k) => (
               <Menu.Item key={k} selectedKeys={[k]}>
                  <a
                     href={router.createHref({
                        ...location,
                        query: {command: k}
                     })}
                  >
                     {label}
                  </a>
               </Menu.Item>
            ))}
         </Menu>
      )

      let selectedCmd = commands[location.query.command]

      return (
         <div>
            <h5>Activity</h5>

            <table>
               <tbody>
                  {_.map(_.slice(messages, 0, 5), ActivityItem)}
               </tbody>

            </table>

            <Row>
               <Col>
                  <Dropdown overlay={CmdMenu}>
                     <a className="ant-dropdown-link">
                        {selectedCmd ? selectedCmd.label : 'Pick Command'}

                        <Icon type="down" />
                     </a>
                  </Dropdown>
               </Col>

               {selectedCmd &&
                  <Col>
                     <CommandInput
                        command={selectedCmd}
                        onChange={(field, value) => this.updateCmd(field, value)}
                     />
                  </Col>}

               <Col>
                  <Button type="primary" onClick={this.onSend} loading={this.state.publishing}>
                     Send a command
                  </Button>
               </Col>

            </Row>
         </div>
      )
   }
}



// WEBPACK FOOTER //
// lib/bundle/dashboard/device/overview/Activity.jsx